import * as Suppliers from './Suppliers'
import * as EmailTemplates from './EmailTemplates'
import * as MemberInvoiceReview from './MemberInvoiceReview'
import * as Emails from './Emails'
import * as Reviews from './Reviews'
import * as Sendings from './Sendings'
import * as Pdfs from './Pdfs'
import { InternalComments } from './InternalComments'
import { NullReporting } from './Nullreporting'
import { NullReportingComments } from './NullReportingComments'
import { ManualMembers } from './ManualMembers'
import { PhoneReviews } from './PhoneReviews'

export const API = {
  Suppliers,
  EmailTemplates,
  Emails,
  Reviews,
  Sendings,
  Pdfs,
  MemberInvoiceReview,
  InternalComments,
  NullReporting,
  NullReportingComments,
  ManualMembers,
  PhoneReviews
}
